import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TextEllipsisPipe } from '../../pipes/text-ellipsis.pipe';
import { SearchService } from '../../search.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-text-truncate',
  templateUrl: './text-truncate.component.html',
  styleUrls: ['./text-truncate.component.scss'],
  providers: [TextEllipsisPipe]
})
export class TextTruncateComponent implements OnInit, OnDestroy {
  @Input('options') options: any;
  @Input('text') oiginalText: string;
  @Input('defaultText') defaultText: string;

  text: string;
  processedText: string;
  hasMore: boolean;
  isExpanded: boolean;
  private showFullTextSubscription: Subscription;

  constructor(private textEllipsisPipe: TextEllipsisPipe,
      private searchService: SearchService) {
  }

  ngOnInit() {
    this.processText();
    this.showFullTextSubscription = this.searchService.showFullText$.subscribe(showText => {
      this.toggleMore(showText);
    });
  }

  processText(): void {
    this.oiginalText = this.oiginalText || this.defaultText;
    if (!this.options || !this.options.limit) {
      this.text = this.oiginalText;
      return;
    }
    this.processedText = this.textEllipsisPipe.transform(this.oiginalText, this.options.limit, '');
    this.hasMore = this.textLength(this.oiginalText) != this.textLength(this.processedText);
    this.text = this.processedText;
  }

  textLength(text: string): number {
    return (text || '').length;
  }

  toggleMore(isExpanded: boolean) {
    this.isExpanded = isExpanded;
    this.text = this.isExpanded ? this.oiginalText : this.processedText;
  }

  ngOnDestroy(): void {
    this.showFullTextSubscription.unsubscribe();
  }
}
